import React, { useState } from "react";
import Swal from "sweetalert2";
import review from '../images/track-icon/Worst.png';
import review01 from '../images/track-icon/Not Good.png';
import review02 from '../images/track-icon/Fine.png';
import review03 from '../images/track-icon/Look Good.png';
import review04 from '../images/track-icon/Very Good.png';
function RatingComponent() {
  const [rating, setRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const ratingImages = [
    review,
    review01,
    review02,
    review03,
    review04,
  ];
  const submitRating = async () => {
    if (!rating) {
      Swal.fire({
        title: "Please select rating",
        icon: "warning",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    try {
      await fetch("https://reqres.in/api/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ rating }),
      });
    } catch (error) {
      console.log("API failed, but ignoring:", error);
    }

    const existingRatings =
      JSON.parse(localStorage.getItem("ratings")) || [];

    existingRatings.push({
      rating,
      time: new Date().toISOString(),
    });

    localStorage.setItem("ratings", JSON.stringify(existingRatings));

    Swal.fire({
      title: "Rating Submitted!",
      text:
        "Thank you! Your rating have been submitted successfully.",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });

    setSubmitted(true);
  };

  return (
    <>
      <div>
        {submitted ? (
          <p className="mt-5" style={{ color: "green" }}>Thanks for your feedback!</p>
        ) : (
          <>
            <div className="mb-2">
              {ratingImages.map((img, index) => {
                const value = index + 1;

                return (
                  <img
                    key={value}
                    src={img}
                    alt={`rating-${value}`}
                    onClick={() => setRating(value)}
                    style={{
                      cursor: "pointer",
                      width: "40px",
                      opacity: rating === value ? 1 : 0.4,
                      transform: rating === value ? "scale(1.2)" : "scale(1)",
                      transition: "0.2s",
                    }}
                  />
                );
              })}
            </div>

            <button className="btn btn-primary" onClick={submitRating}>Submit</button>
          </>
        )}
      </div>
    </>
  );
}

export default RatingComponent;